import api from './api';
import {CHANNELS_SET_ACTIVE} from './channels';

const EVENT_PRODUCTS_SET_PRESET = 'EVENT_PRODUCTS_SET_PRESET';
const EVENT_PRODUCTS_SET_PRODUCT_PRESET = 'EVENT_PRODUCTS_SET_PRODUCT_PRESET';

const initialState = {
  preset: {},
  product: {}
};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case EVENT_PRODUCTS_SET_PRESET:
      return {
        ...state,
        preset: {
          ...state.preset,
          [payload.preset]: payload.items
        }
      };
    case EVENT_PRODUCTS_SET_PRODUCT_PRESET:
      return {
        ...state,
        product: {
          ...state.product,
          [payload.product]: {
            ...(state.product[payload.product] || {}),
            [payload.preset]: payload.items
          }
        }
      };
    case CHANNELS_SET_ACTIVE:
      return initialState;
    default:
      return state;
  }
}

export function fetchEventProductsByPreset(preset) {
  return dispatch => {

    dispatch({type: EVENT_PRODUCTS_SET_PRESET, payload: {preset, items: null}});

    return dispatch(api.getAll(`events/`, {criteria: {preset}}))
      .then(
        eventProductsResponse => dispatch({
          type: EVENT_PRODUCTS_SET_PRESET,
          payload: {preset, items: eventProductsResponse.content.items}
        }),
        eventProductsError => {
          dispatch({type: EVENT_PRODUCTS_SET_PRESET, payload: {preset, items: false}});

          throw eventProductsError;
        }
      );
  };
}

export function fetchEventProductsByProductPreset(product, preset) {
  return dispatch => {
    dispatch({type: EVENT_PRODUCTS_SET_PRODUCT_PRESET, payload: {product, preset, items: null}});

    return dispatch(api.getAll('events/', {criteria: {preset, product}}))
      .then(
        eventProductsResponse => dispatch({
          type: EVENT_PRODUCTS_SET_PRODUCT_PRESET,
          payload: {preset, product, items: eventProductsResponse.content.items}
        }),
        eventProductsError => {
          dispatch({type: EVENT_PRODUCTS_SET_PRODUCT_PRESET, payload: {preset, product, items: false}});

          throw eventProductsError;
        }
      );
  };
}



// WEBPACK FOOTER //
// ./ducks/eventProducts.js